//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MixinBmi from './MixinBmi';
export default {
  name: 'WeightBmi',
  filters: {
    formatMyDate: function formatMyDate(v) {
      return new Date(v).toLocaleDateString();
    }
  },
  mixins: [MixinBmi],
  props: {
    weight: {
      type: Number,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  }
};